import React from "react";

import { IMG_URl } from "../../common/img_url";
import { indexStore } from "../../store/indexStore";
import Visibility from "../utils/Visibility";
import { useTranslation } from "react-i18next";
import Spacer from "../Spacer";
import ProductModel from "../../Models/PorductModel";
import UAEDirhamIcon from "../utils/UAEDirhamIcon";
type ProductRowProps = {
  item: ProductModel;
  displayWaygrid: boolean;
  onClick: (item: ProductModel) => void;
};
function ProductRow(props: ProductRowProps) {
  const { name, description } = indexStore();
  const { t } = useTranslation();

  return (
    <Visibility visible={!props.item.hidden}>
      <div
        className={`flex shadow-card-shadow rounded-md p-3 gap-2  ${
          props.displayWaygrid ? "flex-col" : "flex-row"
        }`}
        onClick={() => props.onClick(props.item)}
        key={props.item.id}
      >
        <img
          src={`${IMG_URl}${props.item.image}`}
          alt="img"
          className={`object-cover rounded-md aspect-square ${
            !props.displayWaygrid ? "min-w-24 w-24 " : "w-full  "
          }`}
        />
        <ProductMed
          item={props.item}
          t={t}
          name={name as keyof ProductModel}
          description={description as keyof ProductModel}
        />
        <Spacer flex />
        <ProductPrice
          displayWaygrid={props.displayWaygrid}
          item={props.item}
          name={name}
        />
      </div>
    </Visibility>
  );
}

export default ProductRow;

const ProductMed = ({
  item,
  t,
  name,
  description,
}: {
  item: ProductModel;
  t: any;
  name: keyof ProductModel;
  description: keyof ProductModel;
}) => {
  return (
    <div className="flex flex-col justify-between gap-2">
      <div className="flex flex-col gap-1">
        <p className="text-[0.79rem] capitalize text-onBackground font-bold text-ellipsis line-clamp-1">
          {String(item[name as keyof ProductModel] ?? "")}
        </p>
        <p className="text-xs text-onBackground text-ellipsis line-clamp-2">
          {String(item[description as keyof ProductModel] ?? "")}
        </p>
      </div>
      <ProductTags item={item} t={t} />
    </div>
  );
};
const ProductTags = ({ item, t }: { item: ProductModel; t: any }) => {
  const tagClass = `text-xs px-2 py-1 bg-primary text-onPrimary rounded-md  `;
  return (
    <Visibility visible={!!(item.new || item.unavailable || item.common)}>
      {" "}
      <div className="flex gap-2 rounde flex-wrap ">
        <Visibility visible={!!item.new}>
          <p className={tagClass}>{t("gloabl.new")}</p>
        </Visibility>
        <Visibility visible={!!item.common}>
          <p className={tagClass}>{t("gloabl.common")}</p>
        </Visibility>
        <Visibility visible={item.unavailable}>
          <p className={tagClass}>{t("gloabl.unavailable")}</p>
        </Visibility>
      </div>
    </Visibility>
  );
};

const ProductPrice = ({
  displayWaygrid,
  item,
  name,
}: {
  displayWaygrid: boolean;
  item: ProductModel;
  name: string;
}) => {
  return (
    <div
      className={`flex shrink-0 justify-end gap-1 text-[0.90rem] font-semibold text-onBackground ${
        displayWaygrid ? "flex-row justify-between" : "flex-col "
      }`}
    >
      <p
        className={`flex items-center gap-1 ${
          item.price_offer
            ? "line-through decoration-primary decoration-solid decoration-2 "
            : ""
        }`}
      >
        <UAEDirhamIcon className="w-3 h-3" />
        {item.price}
      </p>
      <Visibility visible={!!item.price_offer}>
        <p className="text-primary flex items-center gap-1 font-bold">
          <UAEDirhamIcon className="w-3 h-3" /> {item.price_offer}
        </p>
      </Visibility>
    </div>
  );
};
